/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import Publisher from './components/Publisher';
import {FullScreenMessage} from '../shared/components';

const App = ({config}) => {
  if (!config.publisher.token) {
    return <FullScreenMessage messages={['Error: No publish token provided']} />;
  }

  return <Publisher publisher={config.publisher} />;
};

App.propTypes = {config: PropTypes.object.isRequired};

export default App;